import { GetRegionTilesResponseSchema } from './get-region-tiles.schema';
/**
 * The region outlines as vector tiles, served by the API out of the object
 * store rather than off a bucket URL: the bucket stays private, and the
 * caller is whoever may read the regions — any signed-in user.
 *
 * The archive is one PMTiles file. A map reads it with HTTP range requests,
 * a few KB per tile in view, so the route honours `Range` (206 with
 * `Content-Range`) and carries a strong `ETag` the reader checks every range
 * against. `Cache-Control: private` with a lifetime: the outlines change
 * once a year, with the regions.
 */ export const getRegionTilesContract = {
    method: 'GET',
    path: '/api/v2/maps/regions.pmtiles',
    description: 'Serve the region outlines as a PMTiles archive, whole (200) or a byte range of it (206)',
    responseSchema: GetRegionTilesResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            404: 'Not found - the tiles have not been built for this environment (regions:tiles)',
            416: 'Range not satisfiable - the range lies outside the archive'
        }
    }
};

//# sourceMappingURL=get-region-tiles.contract.js.map